// extracted by mini-css-extract-plugin
export default {"popper":"FollowupForm_popper__H9FLa"};